<template>
    <figure class="image circular" @click="$emit('click')">
        <div v-if="!space.photo" class="default">{{space.name.charAt(0)}}</div>
        <img v-else :src="space.photo" alt="Avatar"/>
    </figure>
</template>

<script>
export default {
    name: 'SpaceAvatar',
    props: ['space'],
};
</script>

<style scoped>
    .default {
        color: white;
        font-weight: bold;
        text-align: center;
    }

    .is-24x24 .default {
        margin-top: 0.16rem;
        font-size: 1.1rem;
    }

    .is-96x96 .default {
        margin-top: 0.5rem;
        font-size: 4rem;
    }

    .circular {
        border-radius: 50%;
        position: relative;
        overflow: hidden;
        background: #a6e669;
    }

    .circular img {
        min-width: 100%;
        min-height: 100%;
        width: auto;
        height: auto;
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }
</style>
